export default [
  "Starter",
  "Route 1 (Gras)",
  "Route 22 (Gras)",
  "Vertania Wald (Gras)",
  "Route 2 (Gras)",
  "Route 3 (Gras)",
  "Mondberg (Höhle)",
  "Route 4 (Gras)",
  "Azuria City (Tausch?)",
  "Route 24 (Gras)",
  "Route 25 (Gras)",
  "Route 5 (Gras)",
  "Route 6 (Gras)",
  "Orania City (Angeln oder Tausch)",
  "Route 11 (Gras)",
  "Digda-Höhle (Höhle)",
  "Route 9 (Gras)",
  "Felstunnel (Höhle)",
  "Route 10 (Gras)",
  "Lavandia (Geschenk)",
  "Route 8 (Gras)",
  "Route 7 (Gras)",
  "Prismania City (Geschenk)",
  "Spielhalle",
  "Saffronia City (Lapras Geschenk)",
  "Route 16 (Gras)",
  "Route 17 (Gras)",
  "Route 18 (Gras)",
  "Relaxo",
  "Route 13 (Gras)",
  "Route 14 (Gras)",
  "Route 15 (Gras)",
  "Saffronia City (Kampfarena)",
  "Kraftwerk",
  "Zapdos",
  "Route 19 (Surfen / Angeln)",
  "Route 20 (Surfen / Angeln)",
  "Silph Co Gebäude (Geschenk)",
  "Seeschauminseln (Höhle / Surfen)",
  "Arktos",
  "Route 21 (Surfen / Angeln)",
  "Zinnoberinsel (Geschenk / Angeln)",
  "Fussil",
  "Pokémon-Haus (Herrenhaus) (Gras)",
  "Eiland 1 (Angeln / Surfer)",
  "Glühweg (Gras / Surfer / Angeln)",
  "Eiland 2 (Surfer / Angeln)",
  "Eiland 3 (Gras)",
  "Tri-Eiland-Pfad (Hafen)",
  "Bundbrücke",
  "Beerenforst",
  "Route 23 (Gras)",
  "Siegesstraße (Höhle)",
  "Fossil_2",
  "Fossil-1",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];